import React, { useEffect, useState } from "react";
import { Button } from "react-bootstrap";
import downloadIcon from "../../../Assets/Images/Operation/downloadIcon.svg";
import { compName } from "../../../utils/constant";
import WidgetDetailModal from "../WidgetDetailModal";
import { useSelector } from "react-redux";
import infoIcon from "../../../Assets/Images/Action Icons/infoIcon..svg";
import { useParams } from "react-router-dom";
import emailIcon from "../../../Assets/Images/Email.svg";
import Comments from "../ListingComponent/Comments/Comment";
import moment from "moment";
import {
  Chart as ChartJS,
  CategoryScale,
  LinearScale,
  BarElement,
  LineElement,
  PointElement,
  Title,
  Tooltip,
} from "chart.js";
import { Bar } from "react-chartjs-2";
import "../../../Assets/Styles/component.css";
import { API_URL } from "../../../utils/apiRoutes";
import { apiCall } from "../../../utils/axiosService";
import { apiResponse } from "../../../utils/apiResponse";
import { commonService } from "../../../utils/commonService";
import CancellationExposureDetailModal from "./CancellationExposureDetailModal";
import Skeleton from "react-loading-skeleton";
import Loader from "../../Loader/Loader";
import { MultiSelect } from "primereact/multiselect";

ChartJS.register(
  CategoryScale,
  LinearScale,
  BarElement,
  LineElement,
  PointElement,
  Title,
  Tooltip,
);

const CancellationExposure = ({
  setCompDataFromChild,
  rowIndex,
  colIndex,
  api,
  para,
  setting,
}) => {
  const { snapshottitle, propertyCode, snapshotId } = useParams();
  const propertyDetailFromRTK = useSelector(
    (store) => store.headerProperty?.propertyDetail,
  );
  const defaultAsOfDateFromRTK = useSelector(
    (store) => store.headerProperty?.defaultAsOfDate,
  );
  const [tblids, settblids] = useState({
    CancellationExposureTable: commonService.GenerateGUID(),
  });
  const widgetDetailRef = React.useRef();
  const [widgetModal, setWidgetModal] = useState(false);
  const closeWidgetModal = () => {
    setWidgetModal(false);
  };

  const [showDetail, setShowDetail] = useState(false);
  const [modalData, setModalData] = useState([]);
  const [modalDetailData, setModalDetailData] = useState([]);

  const [selectedMarketSegment, setSelectedMarketSegment] = useState([]);
  const [selectedTempMarketSegment, setSelectedTempMarketSegment] = useState([]);
  const [marketSegmentData, setMarketSegmentData] = useState([]);
  const multiselectRef = React.useRef(null);

  const handleApply = () => {
    setSelectedMarketSegment(selectedTempMarketSegment);

    const selectedMarketSegments = (selectedTempMarketSegment || [])
      .map((item) => item?.toString()?.trim())
      .filter(Boolean);

    const filteredOptions = selectedMarketSegments.length
      ? buildRateCodeOptions(
          ratePlanRawData.filter((item) => {
            const marketSegmentValue = item?.marketsegment_term || item?.market_segmentation || "";
            return selectedMarketSegments.some(
              (segment) => marketSegmentValue?.toString().toUpperCase() === segment.toUpperCase()
            );
          })
        )
      : buildRateCodeOptions(ratePlanRawData);

    const validSelections = (selectedRoomType || [])
      .map((item) => item?.toString()?.trim())
      .filter(Boolean)
      .filter((value) => filteredOptions.some((option) => option.value === value));

    const validTempSelections = (selectedTempRoomType || [])
      .map((item) => item?.toString()?.trim())
      .filter(Boolean)
      .filter((value) => filteredOptions.some((option) => option.value === value));

    setSelectedRoomType(validSelections);
    setSelectedTempRoomType(validTempSelections);

    multiselectRef.current.hide();
  };

  const [selectedRoomType, setSelectedRoomType] = useState([]);
  const [selectedTempRoomType, setSelectedTempRoomType] = useState([]);
  const [roomTypeData, setRoomTypeData] = useState([]);
  const roomTypeMultiselectRef = React.useRef(null);

  const handleRoomTypeApply = () => {
    setSelectedRoomType(selectedTempRoomType);
    roomTypeMultiselectRef.current.hide();
  };

  const [ratePlanRawData, setRatePlanRawData] = useState([]);

  const buildRateCodeOptions = (data) => {
    const uniqueOptions = [];
    const seen = new Set();

    (data || []).forEach((item) => {
      const rateCode = item?.ratecode?.toString()?.trim();
      if (!rateCode || seen.has(rateCode)) {
        return;
      }

      seen.add(rateCode);
      uniqueOptions.push({ label: rateCode, value: rateCode });
    });

    return uniqueOptions;
  };

  const getRatePlanList = async () => {
    let ratePlanListResponse = await apiCall(
      {
        method: "POST",
        url:
          API_URL.BASE_API_URL.RevenueManagement +
          API_URL.REVENUE_RATE_PLAN.GET_LIST,
        body: {
          pageNum: 1,
          pageSize: 10,
          sortColumn: "",
          sortDirection: "asc",
          searchValue: "",
          propertyid: propertyDetailFromRTK?.propertyid,
          ratecode: "",
          ratecodetype_term: "",
          marketsegment_term: "",
          isbarbased: null,
        },
      },
      false
    );

    let response = apiResponse(false, ratePlanListResponse);

    if (response?.isValidate) {
      const data = response?.data?.data || [];
      setRatePlanRawData(data);

      const allOptions = buildRateCodeOptions(data);
      setRoomTypeData(allOptions);
    } else {
      setRatePlanRawData([]);
      setRoomTypeData([]);
      setSelectedRoomType([]);
      setSelectedTempRoomType([]);
    }
  };

  const getTermListByProperty = async () => {
    setMarketSegmentData([]);
    if (propertyDetailFromRTK) {
      let termListResponse = await apiCall(
        {
          method: "POST",
          url:
            API_URL.BASE_API_URL.Configuration +
            API_URL.PROJECT_TERM.GET_LIST_BY_MULTIPLE_CATEGORY_AND_PROPERTY,
          body: { categorynamebycomma: "Market Segment", propertyid: propertyDetailFromRTK?.propertyid },
        },
        false
      );

      let response = apiResponse(false, termListResponse);

      if (response?.isValidate) {
        let data = response?.data?.data?.filter((f) => f.termcategoryname === "Market Segment");
        if (data) {
          let lst = [];
          data.map((item, index) => lst.push({ label: item.term, value: item.term }));
          setMarketSegmentData(lst);
        }
      }
    }
  };

  useEffect(() => {
    if (!ratePlanRawData?.length) {
      setRoomTypeData([]);
      return;
    }

    const selectedMarketSegments = (selectedMarketSegment || [])
      .map((item) => item?.toString()?.trim())
      .filter(Boolean);

    const filteredOptions = selectedMarketSegments.length
      ? buildRateCodeOptions(
          ratePlanRawData.filter((item) => {
            const marketSegmentValue = item?.marketsegment_term || item?.market_segmentation || "";
            return selectedMarketSegments.some(
              (segment) => marketSegmentValue?.toString().toUpperCase() === segment.toUpperCase()
            );
          })
        )
      : buildRateCodeOptions(ratePlanRawData);

    setRoomTypeData(filteredOptions);
  }, [selectedMarketSegment, ratePlanRawData]);

  const footerTemplate = () => (
    <div style={{ padding: "0.5rem", textAlign: "right" }}>
      <Button id={commonService.generateGlobalClickTrackerID("CancellationExposure", "apply", propertyCode)}
        onClick={handleApply}
      >Apply</Button>
    </div>
  );

  const roomTypeFooterTemplate = () => (
    <div style={{ padding: "0.5rem", textAlign: "right" }}>
      <Button id={commonService.generateGlobalClickTrackerID("CancellationExposure", "apply-room-type", propertyCode)}
        onClick={handleRoomTypeApply}
      >Apply</Button>
    </div>
  );

  useEffect(() => {
    getRatePlanList();
    getTermListByProperty();
  }, [propertyDetailFromRTK]);

  const getModalData = async () => {
    let ChannelMixResponse = await apiCall(
      {
        method: "POST",
        url:
          API_URL.BASE_API_URL.SnapShot +
          API_URL.MORNING_BRIEFING.DAILY_CANCELLATIONS_90_DAYS,
        body: {
          asofdate: para?.asOfDate,
          propertycode:
            para?.propertyDetail?.propertycode || para?.propertyCode,
          marketsegment: selectedMarketSegment ? selectedMarketSegment.join(",") : "",
          ratecode: selectedRoomType ? selectedRoomType.join(",") : "",
          // weekNum: 1,
        },
      },
      false,
    );

    let response = apiResponse(false, ChannelMixResponse);

    if (response?.isValidate) {
      let dataFromApi = response?.data?.data || [];
      setModalDetailData(dataFromApi);
    } else {
      setModalDetailData([]);
    }
  };

  const [data, setData] = useState([]);
  const [loading, setLoading] = useState(false);
  const getChannelMixData = async () => {
    setLoading(true);

    let ChannelMixResponse = await apiCall(
      {
        method: "POST",
        url:
          API_URL.BASE_API_URL.SnapShot +
          API_URL.MORNING_BRIEFING.GET_WEEKLY_CANCELLATIONS,
        body: {
          asofdate: para?.asOfDate,
          propertycode:
            para?.propertyDetail?.propertycode || para?.propertyCode,
          marketsegment: selectedMarketSegment ? selectedMarketSegment.join(",") : "",
          ratecode: selectedRoomType ? selectedRoomType.join(",") : "",
        },
      },
      false,
    );

    let response = apiResponse(false, ChannelMixResponse);

    if (response?.isValidate) {
      let dataFromApi = response?.data?.data || [];
      setData(dataFromApi);
    } else {
      setData([]);
    }

    setLoading(false);
  };

  useEffect(() => {
    if (api === 0) {
      const staticWeeklyData = [];
      for (let i = 0; i < 10; i++) {
        staticWeeklyData.push({
          risked_revenue: 1250 + i * 100,
          cancellation_risk: 14.5 - i * 0.5,
          cancellation_delta: 3 + (i % 2),
          total_bookings: 100 + i * 10,
          week_start: moment().subtract(10 - i, "weeks").format("YYYY-MM-DD"),
          week_end: moment().subtract(10 - i, "weeks").add(6, "days").format("YYYY-MM-DD"),
        });
      }
      setData(staticWeeklyData);
      setModalDetailData([
        { Date: "2026-07-29", RiskedRevenue: 450, CancellationRisk: 18.5, RoomSold: 12 },
        { Date: "2026-08-02", RiskedRevenue: 650, CancellationRisk: 22.0, RoomSold: 15 },
      ]);
      setLoading(false);
    } else {
      if (para?.asOfDate && para?.propertyCode) {
        getModalData();
        getChannelMixData();
      }
    }
  }, [para?.asOfDate, para?.propertyCode, api, selectedMarketSegment, selectedRoomType]);

  // Data binding
  const labels = data.map((item, i) => {
    const start = item.week_start ? moment(item.week_start).format("MM/DD") : "";
    const end = item.week_end ? moment(item.week_end).format("MM/DD") : "";
    if (start && end) {
      return [`Wk-${i + 1}`, `(${start} - ${end})`];
    }
    return `Wk-${i + 1}`;
  });
  const dataPoints = data.map((d) => parseFloat(d.risked_revenue || 0));

  const totalRiskedRevenue = data.reduce(
    (sum, item) => sum + parseFloat(item.risked_revenue || 0),
    0,
  );
  const avgCancellationRisk =
    data.length > 0
      ? (
        data.reduce(
          (sum, item) => sum + parseFloat(item.cancellation_risk || 0),
          0,
        ) / data.length
      ).toFixed(1)
      : 0;
  const totalCancellationDelta = data.reduce(
    (sum, item) => sum + parseInt(item.cancellation_delta || 0, 10),
    0,
  );

  const formattedHighRiskOtb = commonService.formateAmount(totalRiskedRevenue);
  const formattedRiskPercentage = `${avgCancellationRisk}%`;
  const formattedFcstDampening =
    totalCancellationDelta > 0
      ? totalCancellationDelta
      : totalCancellationDelta;

  const chartData = {
    labels: labels,
    datasets: [
      {
        label: "Risked Revenue",
        data: dataPoints,
        backgroundColor: labels.map((_, i) =>
          i === 0 ? "#d29922" : "rgba(210, 153, 34, 0.6)",
        ),
        borderRadius: 4,
        borderSkipped: false,
        barPercentage: 0.8,
      },
      {
        label: "Cancellation Risk",
        data: data.map((d) => parseFloat(d.cancellation_risk || 0)),
        backgroundColor: "#06b6d4",
        type: "line",
        borderWidth: 0,
        pointRadius: 0,
        pointHoverRadius: 0,
        yAxisID: "y1",
      },
      {
        label: "Cancellation Delta",
        data: data.map((d) => parseInt(d.cancellation_delta || 0, 10)),
        backgroundColor: "#3b82f6",
        type: "line",
        borderWidth: 0,
        pointRadius: 0,
        pointHoverRadius: 0,
        yAxisID: "y1",
      },
    ],
  };

  // Custom plugin to draw the values above the bars
  const customDataLabels = {
    id: "customDataLabels",
    afterDatasetsDraw: (chart) => {
      const { ctx } = chart;
      chart.data.datasets.forEach((dataset, i) => {
        if (i !== 0) return;
        const meta = chart.getDatasetMeta(i);
        if (!meta.hidden) {
          meta.data.forEach((element, index) => {
            const dataString = commonService.formateAmount(dataset.data[index]);
            ctx.fillStyle = "#d29922"; // Match theme warning color

            const fontSize = 14;
            const fontStyle = "bold";
            const fontFamily = "system-ui, -apple-system, sans-serif";
            ctx.font = `${fontStyle} ${fontSize}px ${fontFamily}`;

            ctx.textAlign = "center";
            ctx.textBaseline = "bottom";

            const position = element.tooltipPosition();
            ctx.fillText(dataString, position.x, position.y - 8);
          });
        }
      });
    },
  };

  const options = {
    responsive: true,
    maintainAspectRatio: false,
    plugins: {
      legend: {
        display: false,
      },
      tooltip: {
        mode: "index",
        intersect: false,
        backgroundColor: "rgba(255, 255, 255, 0.95)",
        titleColor: "#0f172a",
        bodyColor: "#334155",
        borderColor: "#e2e8f0",
        borderWidth: 1,
        padding: 12,
        usePointStyle: false,
        titleFont: {
          size: 14,
          family: "system-ui, -apple-system, sans-serif",
          weight: "bold",
        },
        bodyFont: { size: 13, family: "system-ui, -apple-system, sans-serif" },
        bodySpacing: 6,
        callbacks: {
          label: function (context) {
            let label = context.dataset.label || "";
            if (label) {
              label += ": ";
            }
            if (context.datasetIndex === 0) {
              label += commonService.formateAmount(context.parsed.y);
            } else if (context.datasetIndex === 1) {
              label += context.parsed.y + "%";
            } else if (context.datasetIndex === 2) {
              label += commonService.formateRoom(context.parsed.y);
            }
            return label;
          },
        },
      },
    },
    scales: {
      x: {
        grid: {
          display: false,
          drawBorder: false,
        },
        ticks: {
          color: "#64748b",
          font: {
            size: 13,
            family: "system-ui, -apple-system, sans-serif",
            weight: "600",
          },
        },
        border: {
          display: false,
        },
      },
      y: {
        display: false,
        min: 0,
        suggestedMax: 3000,
      },
      y1: {
        display: false,
      },
    },
    layout: {
      padding: {
        top: 30, // Space for the top labels
      },
    },
  };

  return (
    <div className="widget-container" style={{ position: "relative" }}>
      {api !== 0 && (
        <div className="gap-1 widget-container-menu">
          {/* <Button className="heading-menu-btns" type="button" title="Send Mail">
            <img
              id={commonService.generateGlobalClickTrackerID("CancellationExposure","emailIcon", propertyDetailFromRTK?.propertyid)}
              src={emailIcon}
              alt="emailIcon"
              onClick={() => {
                commonService.fnSendWidgetMail(
                  tblids.CancellationExposureTable,
                  "CancellationExposure",
                  snapshotId,
                  defaultAsOfDateFromRTK,
                  "",
                  para?.widgetId
                );
              }}
            />
          </Button> */}
          <Button className="heading-menu-btns" type="button">
            <img
              id={commonService.generateGlobalClickTrackerID(
                "CancellationExposure",
                "infoIcon",
                propertyDetailFromRTK?.propertyid,
              )}
              src={infoIcon}
              alt="info"
              onClick={() => {
                widgetDetailRef.current = {
                  widgetdetails: "",
                  usernote: "",
                  compName:
                    compName?.CancellationExposure || "CancellationExposure",
                  widgetId: para?.widgetId,
                };
                setWidgetModal(true);
              }}
            />
          </Button>
          {/* <Button className="heading-menu-btns" type="button">
            <img
              src={downloadIcon}
              alt="menuIcon"
              id={commonService.generateGlobalClickTrackerID("CancellationExposure","downloadIcon", propertyDetailFromRTK?.propertyid)}
              onClick={() =>
                commonService.fnExportInCSV(
                  tblids.CancellationExposureTable,
                  `${para?.propertyCode}-CancellationExposure-${moment(new Date()).format("MMDDYYYY")}`
                )
              }
            />
          </Button> */}
        </div>
      )}
      <div className="morning-briefing-header mb-30" style={{ display: "flex", justifyContent: "space-between", alignItems: "center" }}>
        <div className="d-flex gap-2">
          <div style={{ width: "250px" }}>
            <MultiSelect id={commonService.generateGlobalClickTrackerID("CancellationExposure", "multiselect-onchange", propertyCode)}
              ref={multiselectRef}
              filter
              placeholder="Select Market Segment"
              display="values"
              selectedItemsLabel="{0} market segment selected"
              maxSelectedLabels={0}
              closeOnSelect={false}
              value={selectedTempMarketSegment}
              options={marketSegmentData}
              onChange={(e) => {
                setSelectedTempMarketSegment(e.value);
              }}
              panelFooterTemplate={footerTemplate}
            />
          </div>
          <div style={{ width: "250px" }}>
            <MultiSelect id={commonService.generateGlobalClickTrackerID("CancellationExposure", "Room-Type-multiselect-onchange", propertyCode)}
              ref={roomTypeMultiselectRef}
              filter
              placeholder="Select Rate Code"
              display="values"
              selectedItemsLabel="{0} rate code selected"
              maxSelectedLabels={0}
              closeOnSelect={false}
              value={selectedTempRoomType}
              options={roomTypeData}
              onChange={(e) => {
                setSelectedTempRoomType(e.value);
              }}
              panelFooterTemplate={roomTypeFooterTemplate}
            />
          </div>
        </div>
        <div>
          <Button
            id={commonService.generateGlobalClickTrackerID(
              "CancellationExposure",
              "High-Risk-Dates-btn-click",
            )}
            onClick={(e) => {
              e.preventDefault();
              if (api === 0) return;
              setShowDetail(true);
            }}
            className="default-btn primary-btn cursor-pointer ms-0"
          >
            High Risk Dates &rarr;
          </Button>
        </div>
      </div>
      <div className="ce-metric-container">
        <div className="ce-metric-box groupiq-card-block">
          <div className="ce-metric-value warning">
            {loading ? <Skeleton /> : formattedHighRiskOtb}
          </div>
          <div className="ce-metric-label">Risked Revenue</div>
        </div>
        <div className="ce-metric-box groupiq-card-block">
          <div className="ce-metric-value">
            {loading ? <Skeleton /> : formattedRiskPercentage}
          </div>
          <div className="ce-metric-label">Cancellation Risk </div>
        </div>
        <div className="ce-metric-box groupiq-card-block">
          <div className="ce-metric-value">
            {loading ? <Skeleton /> : formattedFcstDampening}
            {/* <span className="ce-metric-unit">RMS</span> */}
          </div>
          <div className="ce-metric-label">Cancellation OTB</div>
        </div>
      </div>

      {loading ? (
        <div style={{ height: "80px", position: "relative" }}>
          <Loader />
        </div>
      ) : (
        <div className="market-share-chart-container">
          <Bar
            data={chartData}
            options={options}
            plugins={[customDataLabels]}
          />
        </div>
      )}
      {api !== 0 && (
        <Comments
          widgetDetails={para}
          editorId={"CancellationExposure" + tblids.CancellationExposureTable}
        />
      )}
      {widgetModal && (
        <WidgetDetailModal
          showModal={widgetModal}
          closeModal={closeWidgetModal}
          data={widgetDetailRef.current}
        />
      )}

      {showDetail && (
        <CancellationExposureDetailModal
          showDetail={showDetail}
          setShowDetail={setShowDetail}
          detailData={modalDetailData}
        />
      )}
    </div>
  );
};

export default CancellationExposure;
